import PropTypes from "prop-types";

// Layouts
import ActionCard from "@/Layouts/components/Cards/ActionCard/ActionCard";

// MUI
import { Box, CardActionArea, Stack, Typography } from "@mui/material";
import { renderIf } from "@/Common/helpers/sonar";
import { useSimpleIntersection } from "@/Common/hooks/Layout/useSimpleIntersection";
import GeolocationIcon from "@/assets/icons/header/GeolocationIcon";

const AccessListsItem = (props) => {
	const {
		index = 0,
		item = null,
		identifier = "_id",
		title = "",
		content = "",
		checked = false,
		disabled = false,
		onActionClick = () => {},
		onActionSelectCheckbox = () => {},
		intersectionRef = null,
		icon = "",
		filteredOut = false,
	} = props;

	const { isIntersecting, observedElementRef } = useSimpleIntersection({
		rootMargin: "400px 0px 400px 0px",
		threshold: 1,
		wrapperContainerRef: intersectionRef,
	});

	return (
		<>
			<Box ref={observedElementRef} />
			{renderIf(!filteredOut && !isIntersecting, <Box className="h-[70px]" />) /* Spacer to keep total scrolling height */}
			{renderIf(
				!filteredOut && isIntersecting,
				<CardActionArea
					disableRipple={true}
					disableTouchRipple={disabled}
					onClick={() => !disabled && onActionClick?.(item?.[identifier])}
				>
					<ActionCard
						title={
							<>
								<Typography
									className={"regular-pt-sans-pro-narrow-label !font-bold !text-[11pt] !w-[185px]"}
									component={"div"}
									noWrap
									sx={{ maxWidth: "290px" }}
								>
									{item?.[title]}
								</Typography>
								{renderIf(
									icon === "location",
									<Stack justifyContent="center" className="absolute top-[10px] right-3 h-6">
										<GeolocationIcon className="text-default h-4 w-4" />
									</Stack>
								)}
							</>
						}
						content={
							<Typography
								className={"regular-pt-sans-pro-narrow-label !text-[11pt] !font-normal !text-default"}
								component={"div"}
							>
								{item?.[content]}
							</Typography>
						}
						contextLength={item?.[content]?.length}
						classes={"action-card-br-10"}
						checkbox
						label={`item_access_control_label_${item?.[identifier]}_${index}`}
						checked={checked || disabled}
						disabled={disabled}
						onChange={() => onActionSelectCheckbox?.(item?.[identifier])}
					/>
				</CardActionArea>
			)}
		</>
	);
};
AccessListsItem.propTypes = {
	index: PropTypes.number,
	item: PropTypes.object,
	identifier: PropTypes.string,
	title: PropTypes.string,
	content: PropTypes.string,
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	onActionClick: PropTypes.func,
	onActionSelectCheckbox: PropTypes.func,
	intersectionRef: PropTypes.object,
	icon: PropTypes.string,
	filteredOut: PropTypes.bool,
};
export default AccessListsItem;
